/**
 * This code was generated by Builder.io.
 */
import React, { useEffect, useState } from "react";
import styles from "./InspectorList.module.css";
import Header from "../../Header/Header";
import InspectorProfile from "../InspectorProfile/InspectorProfile";
import { useNavigate } from "react-router-dom";
import CertifiedAndTrusted from "../../../assets/svg/CertifiedAndTrusted.svg";
import CompleteHomeInspections from "../../../assets/svg/CompleteHomeInspections.svg";
import FastResults from "../../../assets/svg/FastResults.svg";
import BenefitCard from "../../GetQualified/FinancialPreQualification/BenefitCard";
import config from "../../../config";

const cards = [
    {
        id: 1,
        icon: CompleteHomeInspections,
        title: "Complete home inspections",
        description: "From foundation to roof",
    },
    {
        id: 2,
        icon: CertifiedAndTrusted, // Replace with actual icon or image URL
        title: "Certified & Trusted",
        description: "ASHI and InterNACHI accredited",
    },
    {
        id: 3,
        icon: FastResults, // Replace with actual icon or image URL
        title: "Fast Results",
        description: "Detailed reports within 24-48 hours",
    },
];
function InspectorPreQualified() {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const closeModal = () => {
        setShowModal(false);
    };
    useEffect(() => {
        document.title = `Home Inspection Service | ${config.get("COMPANY_NAME")}`;
    }, []);

    return (
        <div className="  ">
            <Header title="Home Inspection " />
            <section
                className={`${styles.inspectorList} tw-mt-[55px]  max-sm:tw-mt-[10px] tw-pb-[10px]  tw-items-center     tw-overflow-y-auto tw-justify-between  tw-bg-background_color `}
            >
                <div></div>
                <div className={`${styles.contentWrapper} max-sm:tw-w-full  tw-gap-5  md:tw-px-3  tw-mt-10 2xl:tw-gap-[30px] tw-font-montserrat`}>
                    <header className={styles.header}>
                        <h1 className={`${styles.title} tw-w-[65%]  max-sm:tw-w-full `}>
                            Professional Home Inspections for Smart Property Decisions
                        </h1>
                        <p className={styles.subtitle}>Thorough as sessments to ensure a seamless buying or selling experience.</p>
                    </header>
                    <div className={` tw-flex tw-gap-[30px] tw-flex-wrap    `}>
                        {cards.map((item) => (
                            <BenefitCard title={item.title} iconSrc={item.icon} description={item.description} />
                        ))}
                    </div>
                    <p className={`${styles.description} max-sm:tw-w-full`}>
                        Whether you’re buying or selling, our top-notch home inspectors provide thorough evaluations to help you make informed
                        decisions. Enjoy peace of mind knowing your property has been expertly inspected.
                    </p>

                    <button
                        onClick={() => navigate("/services/general-info-home-inspection")}
                        className={`${styles.ctaButton} tw-bg-primary hover:tw-bg-primary_hover tw-text-white  tw-font-semibold tw-w-fit tw-mt-4`}
                    >
                        <div className={`${styles.ctaContent}  max-sm:tw-gap-[10px]`}>
                            <span className={`${styles.ctaText} tw-flex tw-text-wrap tw-font-semibold`}>Explore Certified Inspectors</span>
                        </div>
                    </button>
                </div>
                <div className=" "></div>
            </section>
            {showModal && <InspectorProfile onClose={closeModal} />}
        </div>
    );
}

export default InspectorPreQualified;
